import {Controller} from "@hotwired/stimulus";
import {waitForOutletToBeLoaded} from "../../js/functions";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        litigantId: Number,
        litigantName: String,
        source: String,
        flowFromEmail: Boolean,
    };

    static outlets = [
        'document--direct-fee-agreement-modal',
    ];

    async documentDirectFeeAgreementModalOutletConnected() {
        if (this.flowFromEmailValue) {
            dataLayer.push({
                "event": "dataLayer.gaEvent",
                "gaEvent": {
                    "category": "Flow",
                    "action": "Flow from email",
                    "label": "fee agreement",
                },
            });

            await waitForOutletToBeLoaded(() => this.documentDirectFeeAgreementModalOutlet);

            this.openModal();
        }
    }

    openModal() {
        this.documentDirectFeeAgreementModalOutlet.litigantIdValue = this.litigantIdValue;
        this.documentDirectFeeAgreementModalOutlet.litigantNameValue = this.litigantNameValue;
        this.documentDirectFeeAgreementModalOutlet.sourceValue = this.sourceValue;
        this.documentDirectFeeAgreementModalOutlet.open();
    }
}
